import { Badge, Card, Group, ScrollArea, Stack, Text, Title } from "@mantine/core";
import { EventSelectionListProps, formatTime } from "./types";

export const EventSelectionList = ({
  events,
  selectedEventId,
  onSelectEvent,
}: EventSelectionListProps) => {
  if (events.length === 0) {
    return (
      <Card withBorder padding="lg">
        <Text c="dimmed" ta="center">
          변경 가능한 이벤트가 없습니다
        </Text>
      </Card>
    );
  }

  return (
    <ScrollArea h={400}>
      <Stack gap="md">
        {events.map((event) => {
          const isSelected = event.id === selectedEventId;
          const activeAttendees = event.reservationRequests.filter(
            (req) => req.status !== "CANCELLED" && req.status !== "CANCELLED_NO_REFUND"
          );
          const totalAttendees = activeAttendees.length;

          return (
            <Card
              key={event.id}
              shadow="sm"
              padding="lg"
              radius="md"
              withBorder
              onClick={() => onSelectEvent(event.id)}
              style={{
                cursor: "pointer",
                borderColor: isSelected ? "#228be6" : undefined,
                borderWidth: isSelected ? "2px" : "1px",
                backgroundColor: isSelected ? "#f0f7ff" : undefined,
              }}
            >
              <Group justify="space-between" align="flex-start">
                <div style={{ flex: 1 }}>
                  <Title order={5} c="black" mb="xs">
                    {formatTime(event.startTime)}
                  </Title>
                  <Text c="gray" size="sm" mb="xs">
                    📍 {event.locationName}
                  </Text>
                  <Badge size="md" color="blue">
                    {totalAttendees} / {event.capacity}명
                  </Badge>
                </div>
                {isSelected && (
                  <Badge size="lg" color="blue" variant="filled">
                    선택됨
                  </Badge>
                )}
              </Group>

              {totalAttendees > 0 && (
                <div style={{ marginTop: "12px" }}>
                  <Text c="dimmed" size="xs" mb="xs">
                    현재 참석자
                  </Text>
                  <Group gap="xs">
                    {activeAttendees.slice(0, 5).map((req) => (
                      <Badge key={req.id} size="sm" variant="outline">
                        {req.user.nickname}
                      </Badge>
                    ))}
                    {totalAttendees > 5 && (
                      <Badge size="sm" variant="outline">
                        +{totalAttendees - 5}
                      </Badge>
                    )}
                  </Group>
                </div>
              )}
            </Card>
          );
        })}
      </Stack>
    </ScrollArea>
  );
};
